//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns invoice address for the specified contact ID.
 * @param contactId (optional) 
 */
export function getInvoiceAddress(contactId?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.InvoiceAddressDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/invoice-address?";
    if (contactId === null)
        throw new Error("The parameter 'contactId' cannot be null.");
    else if (contactId !== undefined)
        url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetInvoiceAddress,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetInvoiceAddress?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetInvoiceAddress(_response);
    });
}

function processGetInvoiceAddress(response: AxiosResponse): Promise<Types.InvoiceAddressDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initInvoiceAddressDto(resultData200);
        return Promise.resolve<Types.InvoiceAddressDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InvoiceAddressDto>(null as any);
}

/**
 * Returns invoice address from user's current open internal repair order.
 */
export function getInternalRepairOrderInvoiceAddress(config?: AxiosRequestConfig | undefined): Promise<Types.InvoiceAddressDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/invoice-address/internal-order";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetInternalRepairOrderInvoiceAddress,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetInternalRepairOrderInvoiceAddress?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetInternalRepairOrderInvoiceAddress(_response);
    });
}

function processGetInternalRepairOrderInvoiceAddress(response: AxiosResponse): Promise<Types.InvoiceAddressDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initInvoiceAddressDto(resultData200);
        return Promise.resolve<Types.InvoiceAddressDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InvoiceAddressDto>(null as any);
}

/**
 * Creates a new repair draft in user's current open internal order.
 */
export function createRepairOrderDraft(dto: Types.CreateRepairOrderDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/repairs-order/drafts";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateRepairOrderDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateRepairOrderDraft,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateRepairOrderDraft?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateRepairOrderDraft(_response);
    });
}

function processCreateRepairOrderDraft(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Returns user's open repair drafts grouped with shared internal incoming number.
 */
export function getUserOpenRepairOrderDrafts(config?: AxiosRequestConfig | undefined): Promise<Types.RepairOrderDraftListDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/drafts";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetUserOpenRepairOrderDrafts,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetUserOpenRepairOrderDrafts?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetUserOpenRepairOrderDrafts(_response);
    });
}

function processGetUserOpenRepairOrderDrafts(response: AxiosResponse): Promise<Types.RepairOrderDraftListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRepairOrderDraftListDto(resultData200);
        return Promise.resolve<Types.RepairOrderDraftListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RepairOrderDraftListDto>(null as any);
}

/**
 * Creates a new open internal repair order for current user or updates the existing open one.
 */
export function createInternalRepairOrder(dto: Types.CreateInternalRepairOrderDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/repairs-order/internal-order";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateInternalRepairOrderDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateInternalRepairOrder,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateInternalRepairOrder?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateInternalRepairOrder(_response);
    });
}

function processCreateInternalRepairOrder(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Requests device data by serial number or service product.
 * @param serialNumber (optional) Selected serial number (seriennummer)
 * @param serviceProductId (optional) Device id (serviceprodukt). This is needed to find certain device when the serial number belongs to several devices.
 * @param userLanguage (optional) 
 */
export function requestDevice(serialNumber?: string | null | undefined, serviceProductId?: string | null | undefined, userLanguage?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RepairDeviceDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/request-device?";
    if (serialNumber !== undefined && serialNumber !== null)
        url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
    if (serviceProductId !== undefined && serviceProductId !== null)
        url_ += "ServiceProductId=" + encodeURIComponent("" + serviceProductId) + "&";
    if (userLanguage === null)
        throw new Error("The parameter 'userLanguage' cannot be null.");
    else if (userLanguage !== undefined)
        url_ += "userLanguage=" + encodeURIComponent("" + userLanguage) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRequestDevice,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigRequestDevice?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRequestDevice(_response);
    });
}

function processRequestDevice(response: AxiosResponse): Promise<Types.RepairDeviceDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRepairDeviceDto(resultData200);
        return Promise.resolve<Types.RepairDeviceDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RepairDeviceDto>(null as any);
}

/**
 * Applies patch to a repair draft owned by current user.
 */
export function patchRepairOrderDraft(id: number, dto: Types.PatchRepairOrderDraftDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/repairs-order/drafts/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchRepairOrderDraftDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchRepairOrderDraft,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchRepairOrderDraft?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchRepairOrderDraft(_response);
    });
}

function processPatchRepairOrderDraft(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Deletes an open repair draft owned by current user.
 */
export function deleteRepairOrderDraft(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/repairs-order/drafts/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteRepairOrderDraft,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteRepairOrderDraft?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteRepairOrderDraft(_response);
    });
}

function processDeleteRepairOrderDraft(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Submits all user's open repair drafts to Abas.
 */
export function submitRepairOrder(config?: AxiosRequestConfig | undefined): Promise<Types.SubmitRepairOrderResponseDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/submit";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSubmitRepairOrder,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSubmitRepairOrder?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSubmitRepairOrder(_response);
    });
}

function processSubmitRepairOrder(response: AxiosResponse): Promise<Types.SubmitRepairOrderResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSubmitRepairOrderResponseDto(resultData200);
        return Promise.resolve<Types.SubmitRepairOrderResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SubmitRepairOrderResponseDto>(null as any);
}

/**
 * Returns sales positions from Abas VIEW command for the specified repairs order ID.
 */
export function getSalesView(repairsOrderId: string, config?: AxiosRequestConfig | undefined): Promise<Types.SalesViewDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/view";
    if (repairsOrderId === undefined || repairsOrderId === null)
      throw new Error("The parameter 'repairsOrderId' must be defined.");
    url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSalesView,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetSalesView?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSalesView(_response);
    });
}

function processGetSalesView(response: AxiosResponse): Promise<Types.SalesViewDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSalesViewDto(resultData200);
        return Promise.resolve<Types.SalesViewDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SalesViewDto>(null as any);
}

/**
 * Runs Abas print command for the sales document found by repairs order ID and returns generated document info.
 */
export function printSales(repairsOrderId: string, config?: AxiosRequestConfig | undefined): Promise<Types.SalesPrintDto> {
    let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/print";
    if (repairsOrderId === undefined || repairsOrderId === null)
      throw new Error("The parameter 'repairsOrderId' must be defined.");
    url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPrintSales,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPrintSales?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPrintSales(_response);
    });
}

function processPrintSales(response: AxiosResponse): Promise<Types.SalesPrintDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSalesPrintDto(resultData200);
        return Promise.resolve<Types.SalesPrintDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SalesPrintDto>(null as any);
}

/**
 * Generates and downloads a repair order PDF for the specified incoming number(s).
 * @param repairsOrderIds (optional) 
 */
export function printRepairOrder(repairsOrderIds?: string[] | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/repairs-order/print?";
    if (repairsOrderIds === null)
        throw new Error("The parameter 'repairsOrderIds' cannot be null.");
    else if (repairsOrderIds !== undefined)
        repairsOrderIds && repairsOrderIds.forEach(item => { url_ += "repairsOrderIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        responseType: "blob",
        ..._requestConfigPrintRepairOrder,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPrintRepairOrder?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPrintRepairOrder(_response);
    });
}

function processPrintRepairOrder(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

/**
 * Downloads a cost-estimate document from Abas through the current application.
 */
export function downloadSalesPrint(repairsOrderId: string, abasFileId: string, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/print/{abasFileId}";
    if (repairsOrderId === undefined || repairsOrderId === null)
      throw new Error("The parameter 'repairsOrderId' must be defined.");
    url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
    if (abasFileId === undefined || abasFileId === null)
      throw new Error("The parameter 'abasFileId' must be defined.");
    url_ = url_.replace("{abasFileId}", encodeURIComponent("" + abasFileId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        responseType: "blob",
        ..._requestConfigDownloadSalesPrint,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownloadSalesPrint?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownloadSalesPrint(_response);
    });
}

function processDownloadSalesPrint(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

/**
 * Approves cost estimate for the specified repairs order ID.
 */
export function approveCostEstimate(repairsOrderId: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/approve";
    if (repairsOrderId === undefined || repairsOrderId === null)
      throw new Error("The parameter 'repairsOrderId' must be defined.");
    url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigApproveCostEstimate,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigApproveCostEstimate?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processApproveCostEstimate(_response);
    });
}

function processApproveCostEstimate(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetInvoiceAddress: Partial<AxiosRequestConfig> | null;
export function getGetInvoiceAddressRequestConfig() {
  return _requestConfigGetInvoiceAddress;
}
export function setGetInvoiceAddressRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetInvoiceAddress = value;
}
export function patchGetInvoiceAddressRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetInvoiceAddress = patch(_requestConfigGetInvoiceAddress ?? {});
}

let _requestConfigGetInternalRepairOrderInvoiceAddress: Partial<AxiosRequestConfig> | null;
export function getGetInternalRepairOrderInvoiceAddressRequestConfig() {
  return _requestConfigGetInternalRepairOrderInvoiceAddress;
}
export function setGetInternalRepairOrderInvoiceAddressRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetInternalRepairOrderInvoiceAddress = value;
}
export function patchGetInternalRepairOrderInvoiceAddressRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetInternalRepairOrderInvoiceAddress = patch(_requestConfigGetInternalRepairOrderInvoiceAddress ?? {});
}

let _requestConfigCreateRepairOrderDraft: Partial<AxiosRequestConfig> | null;
export function getCreateRepairOrderDraftRequestConfig() {
  return _requestConfigCreateRepairOrderDraft;
}
export function setCreateRepairOrderDraftRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateRepairOrderDraft = value;
}
export function patchCreateRepairOrderDraftRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateRepairOrderDraft = patch(_requestConfigCreateRepairOrderDraft ?? {});
}

let _requestConfigGetUserOpenRepairOrderDrafts: Partial<AxiosRequestConfig> | null;
export function getGetUserOpenRepairOrderDraftsRequestConfig() {
  return _requestConfigGetUserOpenRepairOrderDrafts;
}
export function setGetUserOpenRepairOrderDraftsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetUserOpenRepairOrderDrafts = value;
}
export function patchGetUserOpenRepairOrderDraftsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetUserOpenRepairOrderDrafts = patch(_requestConfigGetUserOpenRepairOrderDrafts ?? {});
}

let _requestConfigCreateInternalRepairOrder: Partial<AxiosRequestConfig> | null;
export function getCreateInternalRepairOrderRequestConfig() {
  return _requestConfigCreateInternalRepairOrder;
}
export function setCreateInternalRepairOrderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateInternalRepairOrder = value;
}
export function patchCreateInternalRepairOrderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateInternalRepairOrder = patch(_requestConfigCreateInternalRepairOrder ?? {});
}

let _requestConfigRequestDevice: Partial<AxiosRequestConfig> | null;
export function getRequestDeviceRequestConfig() {
  return _requestConfigRequestDevice;
}
export function setRequestDeviceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRequestDevice = value;
}
export function patchRequestDeviceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRequestDevice = patch(_requestConfigRequestDevice ?? {});
}

let _requestConfigPatchRepairOrderDraft: Partial<AxiosRequestConfig> | null;
export function getPatchRepairOrderDraftRequestConfig() {
  return _requestConfigPatchRepairOrderDraft;
}
export function setPatchRepairOrderDraftRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchRepairOrderDraft = value;
}
export function patchPatchRepairOrderDraftRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchRepairOrderDraft = patch(_requestConfigPatchRepairOrderDraft ?? {});
}

let _requestConfigDeleteRepairOrderDraft: Partial<AxiosRequestConfig> | null;
export function getDeleteRepairOrderDraftRequestConfig() {
  return _requestConfigDeleteRepairOrderDraft;
}
export function setDeleteRepairOrderDraftRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteRepairOrderDraft = value;
}
export function patchDeleteRepairOrderDraftRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteRepairOrderDraft = patch(_requestConfigDeleteRepairOrderDraft ?? {});
}

let _requestConfigSubmitRepairOrder: Partial<AxiosRequestConfig> | null;
export function getSubmitRepairOrderRequestConfig() {
  return _requestConfigSubmitRepairOrder;
}
export function setSubmitRepairOrderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSubmitRepairOrder = value;
}
export function patchSubmitRepairOrderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSubmitRepairOrder = patch(_requestConfigSubmitRepairOrder ?? {});
}

let _requestConfigGetSalesView: Partial<AxiosRequestConfig> | null;
export function getGetSalesViewRequestConfig() {
  return _requestConfigGetSalesView;
}
export function setGetSalesViewRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSalesView = value;
}
export function patchGetSalesViewRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSalesView = patch(_requestConfigGetSalesView ?? {});
}

let _requestConfigPrintSales: Partial<AxiosRequestConfig> | null;
export function getPrintSalesRequestConfig() {
  return _requestConfigPrintSales;
}
export function setPrintSalesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPrintSales = value;
}
export function patchPrintSalesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPrintSales = patch(_requestConfigPrintSales ?? {});
}

let _requestConfigPrintRepairOrder: Partial<AxiosRequestConfig> | null;
export function getPrintRepairOrderRequestConfig() {
  return _requestConfigPrintRepairOrder;
}
export function setPrintRepairOrderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPrintRepairOrder = value;
}
export function patchPrintRepairOrderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPrintRepairOrder = patch(_requestConfigPrintRepairOrder ?? {});
}

let _requestConfigDownloadSalesPrint: Partial<AxiosRequestConfig> | null;
export function getDownloadSalesPrintRequestConfig() {
  return _requestConfigDownloadSalesPrint;
}
export function setDownloadSalesPrintRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownloadSalesPrint = value;
}
export function patchDownloadSalesPrintRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownloadSalesPrint = patch(_requestConfigDownloadSalesPrint ?? {});
}

let _requestConfigApproveCostEstimate: Partial<AxiosRequestConfig> | null;
export function getApproveCostEstimateRequestConfig() {
  return _requestConfigApproveCostEstimate;
}
export function setApproveCostEstimateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigApproveCostEstimate = value;
}
export function patchApproveCostEstimateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigApproveCostEstimate = patch(_requestConfigApproveCostEstimate ?? {});
}